export default __webpack_public_path__ + "static/media/cryptogamingpoolLOGO.5fc27964.png";